import { motion } from "framer-motion";
import React from "react";
import { EditDailyModal } from "./editDaily";
import Button from "../../form/button";
import Checkbox from "../../form/checkbox";
import { IDailyRecord } from "../../../lib/types";
import pb from "../../../lib/pocketbase";
import { useToast } from "../../ui/use-toast";

interface DailyTodoProps {
    todo: IDailyRecord;
    todos: IDailyRecord[];
    setTodos: React.Dispatch<React.SetStateAction<IDailyRecord[]>>;
}
export default function DailyTodo({ todo, todos, setTodos }: DailyTodoProps) {
    const { toast } = useToast();
    function deleteTodo(todo: IDailyRecord) {
        setTodos(todos.filter((t) => t.id !== todo.id));
        pb.collection("daily")
            .delete(todo.id)
            .then((response) => {
                toast({
                    title: `❗️ Deleted!`,
                    description: `I have deleted '${todo.text}'`
                });
            });
    }

    function toggleTodo(todo: IDailyRecord) {
        let newTodos = [...todos];
        for (let i = 0; i < newTodos.length; i++) {
            if (newTodos[i].id === todo.id) {
                newTodos[i].completed = !todo.completed;
                break; // Remove this line if you want to change all matching objects
            }
        }
        setTodos(newTodos);
        pb.collection("daily").update(todo.id, {
            completed: todo.completed
        });
    }

    return (
        <motion.div key={todo.id} initial={{ x: 300, opacity: 0 }} animate={{ x: 0, opacity: 1 }} exit={{ x: -300, opacity: 0 }} className="flex flex-col gap-4">
            <div className="flex items-center gap-4 text-slate-600 dark:text-slate-200">
                <Checkbox onClick={() => toggleTodo(todo)} checked={todo.completed} />

                <button
                    onClick={() => {
                        toggleTodo(todo);
                    }}
                    className={`${
                        todo.completed ? "italic text-slate-300 dark:text-slate-600" : ""
                    } flex-grow text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-5 dark:ring-offset-slate-900 focus-visible:dark:ring-slate-700`}>
                    <div className="relative w-fit">
                        <motion.hr animate={{ width: todo.completed ? "100%" : 0 }} className={`absolute top-3 w-0 rounded border-t-2 border-slate-400 dark:border-slate-600 ${todo.completed ? "block" : "hidden"}`} />
                        {todo.text}
                    </div>
                </button>

                {todo.completed ? (
                    <Button onClick={() => deleteTodo(todo)} size="ghost" variant="ghost" className="group">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="h-5 w-5 text-slate-400 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-5 group-hover:text-red-400  dark:text-slate-600 dark:ring-offset-slate-900 focus-visible:dark:ring-slate-700 dark:group-hover:text-red-400">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                            />
                        </svg>
                    </Button>
                ) : (
                    <EditDailyModal todo={todo} todos={todos} setTodos={setTodos} />
                )}
            </div>
            <hr className="border-slate-200 dark:border-slate-800" />
        </motion.div>
    );
}
